export const REACT_APP_API_BASE_URL =
  "https://rd-dashboard-api.reservatoriodedopamina.com.br";
